import React from "react";

const LearnMore = () => (
  <button
    className="font-titleFont text-xl text-white
  bg-darkPink transition-hover duration-300 font-semibold rounded-md w-52 h-14 hover:bg-[#00442B] hover:text-white"
  >
    Learn More
  </button>
);

export default LearnMore;
